// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SurveySessionValueReadModels {
    static getAttributeTypeMap() {
        return SurveySessionValueReadModels.attributeTypeMap;
    }
}
SurveySessionValueReadModels.discriminator = undefined;
SurveySessionValueReadModels.additionalProperties = false;
SurveySessionValueReadModels.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
    {
        "name": "data",
        "baseName": "data",
        "type": ""
    },
];
//# sourceMappingURL=surveySessionValueReadModels.js.map